class Locator {
  $filter = document.querySelectorAll(".storeifyapp_stores_tags_filter");
  constructor() {
    // this.bindLocator();
  }
  locationParam = ""
  bindLocator() {
    let $stores = document.querySelectorAll("[data-store-url]");

    $stores.forEach((store) => {
      store.addEventListener("click", (e) => {
        let url = e.target.getAttribute("data-store-url");
        if (url) window.location.href = url;
        else
          window.location.href =
            e.target.parentElement.getAttribute("data-store-url");
      });
    });
  }
  static async filters(reset = false) {
    if (reset) {
      document.querySelector(".tags").remove();
    }
    this.$filter = document.querySelectorAll(".storeifyapp_stores_tags_filter");
    document
      .querySelector(".pac-target-input")
      .setAttribute("placeholder", "Enter Zip Code or Address and hit search");
    const urlParams = new URLSearchParams(window.location.search);
    const param = urlParams.get("key");
    this.locationParam = param;
   
    if (param == "ecommerce") {
      document
        .querySelector("#main-slider-storelocator")
        .classList.add("online");
      document.querySelector(".storeify-stl-header").style.display = "none";
    } else {
      document
      .querySelector("#main-slider-storelocator")
      .classList.add("not-online");
      document.querySelector("#stores-tags-filter").style.display = "none";
      document.querySelector(
        ".chose-search-slt [value='store']"
      ).style.display = "none";
      document.querySelector("#getbylocal").style.display = "none";
    }
    document.querySelector(
      ".bootstrap-storeifyapps select.form-control-storeify"
    ).disabled = true;
    let $header = document.querySelector("#results-slt");
    document.querySelector("#submit-search").classList.add("patch");

    let $tagElements = Locator.addTagsContainer($header, param);
    let exists = false;

    this.$filter.forEach((element) => {
      if (element.value.indexOf("category_") !== -1) {
        let $tagItem = document.createElement("div");
        $tagItem.classList = "item";
        $tagItem.innerHTML = `<span class="item-category-dealer" data-name="${element.value.replace(
          "category_",
          ""
        )}" > ${element.value.replace(
          "category_",
          ""
        )} <input  name="category_dealer" type="checkbox" ${
          param != "ecommerce" ? "" : "" // checked ?
        }> <span class="checkmark"></span></span>`;
        $tagItem.addEventListener("click", (e) => {
          const checked = document.querySelectorAll(".tags input:checked");
          checked.forEach((checkedElement) => {
            
            const parent = checkedElement.closest(".item-category-dealer");
            let input = e.target.closest(".item-category-dealer");

            if (!input) {
              if (e.target.querySelector(".item-category-dealer"))
                input = e.target.querySelector(".item-category-dealer");
              else input = e.target;
            }

            if (
              parent.getAttribute("data-name") !==
              input.getAttribute("data-name")
            ) {
              checkedElement.checked = false;
            }
          });

          let $clickedInput = e.target.querySelector("input");

          if ($clickedInput) {
            $clickedInput.checked = !$clickedInput.checked;
          } else {
            e.checked = !e.checked;
          }
          const newChecked = document.querySelectorAll(".tags input:checked");
          Locator.resetTags();
          if (newChecked.length > 0) element.parentElement.click();

          setTimeout(() => {
            if (document.getElementById("num-rs").innerText == 0)
              document.getElementById("no-dealers").style.display = "block";
            else document.getElementById("no-dealers").style.display = "none";
            Locator.bindingDetail(param);
            Locator.bindingPopupInMap(param);
          }, 500);
        });

        // if (param !== "ecommerce" && param !== "distributor")
        //   element.parentElement.click();

        if (param !== "distributor") $tagElements.appendChild($tagItem);
        return;
      }
      if (param == element.value) {
        element.parentElement.click();
        exists = true;
      }
   
    });

    if (!exists) {
      let $app = document.querySelector("#storeifyapps-storelocator-shortcode");
      var alert = document.createElement("div");
      alert.className = "store-locator-empty";
      alert.innerText = `DEALEARS NOT FOUND`;
      $app.parentNode.insertBefore(alert, $app.nextSibling);
      $app.style.display = "none";
      document.querySelector(".lds-roller").style.display = "none";
    } else {
      setTimeout(() => {
        document
          .querySelector("#storeifyapps-storelocator-shortcode")
          .classList.add("active");
        if (param == "ecommerce") {
          document.querySelector(".map-tab-ggmap").style.display = "none";
          document.querySelector(".map-tab-result").style.minWidth = "100%";

          let $slider = document.querySelector("#main-slider-storelocator");

          $slider.classList.add("ecommerce");

          // $slider
          //   .querySelectorAll(".item.thumbnail")
          //   .forEach(($item) => ($item.style.height = 400));
          document.querySelector("#sl-tab-list").click();
          document.querySelector(".map-tab-mobile-bnt").style.display = "none";
        }
        if (param == "distributor") {
          document.querySelector(
            ".storelocator-search .tags"
          ).style.marginBottom = 0;
        }
        Locator.bindingDetail(param);

        Locator.bindingPopupInMap(param);
        document.querySelector(".lds-roller").style.display = "none";
      }, 500);
    }
    document.querySelectorAll(".reset").forEach((element) => {
      element.innerHTML = "Reset";
      element.style.display = "none";
      element.addEventListener("click", (e) => {
        Locator.resetLogic();
      });
    });

    document.querySelector("#submit-search").addEventListener("click", (e) => {
      const value = document.getElementById("address").value;
      if (value == "") {
        document.getElementById("reset-search").click();
      }
      setTimeout(() => {
        Locator.bindingDetail(param);
        Locator.bindingPopupInMap(param);
      }, 500);
    });
    document
      .querySelector("#address.pac-target-input")
      .addEventListener("keyup", (e) => {
        if (e.key == "Enter") {
          const value = document.getElementById("address").value;

          if (value == "") {
            document.getElementById("reset-search").click();
          }

          setTimeout(() => {
            Locator.bindingDetail(param);
            Locator.bindingPopupInMap(param);
          }, 500);
        }

        let $radiusComponent = document.querySelector(".search-radius-box");
        if (e.target.value == "") {
          $radiusComponent.style.display = "none";
          // document.getElementById("reset-search").click();
        } else $radiusComponent.style.display = "block";
      });

    document.querySelector("#radius_search").addEventListener("change", () => {
      document.querySelector("#submit-search").click();
    });
    Locator.addDataRange()
    const partF = new PartFinderForm("#custom-part-finder")
    await partF.init();
  }
  static resetTags() {
    let $tagMaps = document.querySelectorAll(".storeifyapp_stores_tags_filter");

    $tagMaps.forEach((element) => {
      if (element.value.indexOf("category_") !== -1) {
        if (element.checked) {
          element.parentElement.click();
        }
        element.checked = false;
      }
    });
  }

  static resetLogic() {
    document.querySelector("#results-slt").style.opacity = "0";

    setTimeout(() => {
      Locator.filters(true);
    }, 500);
    setTimeout(() => {
      document.querySelector("#results-slt").style.opacity = "1";
    }, 2000);
  }
  static bindingDetail(param) {
    let $items = document.querySelector("#results-slt");

    if ($items.style.display == "none") {
      document.getElementById("no-dealers").style.display = "block";
    } else {
      document.getElementById("no-dealers").style.display = "none";
    }
    setTimeout(() => {
      document.querySelectorAll("#results-slt .item").forEach((element) => {
        
        element.addEventListener("click", (e) => {
          const dName = e.target
    .closest(".item")
    .querySelector(".store-name").innerText;
          Locator.GAEvents(dName);

          if (param === "ecommerce") {
            // document.querySelector(".popup-locator-form").style.display =
            //   "flex";

            document
              .querySelectorAll(".popup-locator-form .dealer-name")
              .forEach(($dealerName) => {
                $dealerName.innerText = e.target
                  .closest(".item")
                  .querySelector(".store-name").innerText;
              });
            // document.getElementById("general-contact-form").style.display = "block";

            window.open(
              element
                .querySelector(".storeify-storelocator-web")
                .getAttribute("href"),
              "_blank"
            );
          } else {
            Locator.formattingAddress();
           
            let link = document.createElement("div");
            link.className = "contact-us-popup";
            link.innerHTML = `<span>Contact</span>`;
            link.addEventListener("click", (e) => {
              document.querySelector(".popup-locator-form").style.display =
                "flex";
              document
                .querySelectorAll(".popup-locator-form .dealer-name")
                .forEach(($dealerName) => {
                  $dealerName.innerText =
                    e.target.getAttribute("data-store-name") ??
                    e.target.parentElement.getAttribute("data-store-name");
                });

              document.getElementById("dealeremail").value =
                document.querySelector(".marker-envelope a")?.innerText || "";
                const dealerName = document.querySelector('.table-store-marker .store-name').innerText
                Locator.GAEvents(dealerName,'contact_button')
            });
            document.getElementById("sl-tab-map").click();
            Locator.showForm(param);
            setTimeout(() => {
              if (
                document.querySelector(".table-store-marker .contact-us-popup")
              ) {
                document
                  .querySelectorAll(".table-store-marker .contact-us-popup")
                  .forEach((e) => {
                    e.remove();
                  });
              }
              link.setAttribute(
                "data-store-name",
                document.querySelector(".table-store-marker .store-name")
                  .innerText
              );
              document
                .querySelectorAll(".storeify-storelocator-web")
                .forEach((link) => link.setAttribute("target", "_blank"));
                
              document.querySelector(".table-store-marker").appendChild(link);
            }, 700);
          }
        });
      });
    }, 500);
  }
  static formattingAddress() {
    setTimeout(() => {
      let $addressFormat = document.querySelector(".table-store-marker p");
      if($addressFormat){
        $addressFormat.style.display = "none";
        let position = 0;
        let format = $addressFormat.innerText.replaceAll(",", (e) => {
          if (position == 0) {
            ++position;
            return "\n";
          }
          ++position;
  
          return position >= 4 ? "\n" : e;
        });
        $addressFormat.innerText = format.replace("place", "");
        $addressFormat.style.display = "block";
      }
      if(document.querySelector('.table-store-marker .storeify-storelocator-web')){
        document.querySelector('.table-store-marker .storeify-storelocator-web').innerText = "Website";
        document.querySelector('.table-store-marker .storeify-storelocator-web').addEventListener('click',e => {
          const dName = e.target.closest('.row').querySelector('.store-name').innerText;
          Locator.GAEvents(dName,'website_link')
        })
      }
      
    }, 100);
  }
  static bindingPopupInMap(locator_type) {
    document.querySelector("#storeifyapps-storelocator-shortcode").addEventListener("click",e => {
      setTimeout(()=>{
        if(!document.querySelector('.contact-us-popup'))
        Locator.makeContactButton(locator_type);
      },1000)
    })   
  }
  static showForm(param) {
    switch (param) {
      case "installer":
        document.getElementById("general-contact-form").style.display = "block";
        break;
      case "retailer":
        document.getElementById("general-contact-form").style.display = "block";
        break;
      case "distributor":
        document.getElementById("dealer-locator-form").style.display = "block";
      default:
        break;
    }
  }
  static addTagsContainer($header, param) {
    let tagElements = document.createElement("div");
    tagElements.className = "tags";
    if (param == "ecommerce") tagElements.classList.add("ecommerce");

    if (!document.getElementById("no-dealers")) {
      let noDealers = document.createElement("div");
      noDealers.id = "no-dealers";
      noDealers.innerHTML =
        "Oh No, goose egg! Try expanding the radius above, or feel free to hit us up and we can help, right this way!! <a href='https://awe-tuning.com/pages/contact' target='_blank'>Contact Us</a>";
      $header.parentElement.prepend(noDealers);
    }
    $header.parentElement.prepend(tagElements);

    return tagElements;
  }
  static makeContactButton(locator_type){
    Locator.formattingAddress();
    
    if (document.querySelector(".table-store-marker .contact-us-popup")) {
      document
        .querySelectorAll(".table-store-marker .contact-us-popup")
        .forEach((e) => {
          e.remove();
        });
    }
   
    var link = document.createElement("div");
    link.className = "contact-us-popup";
    link.innerHTML = `<span>Contact</span>`;
    link.addEventListener("click", () => {
      document.querySelector(".popup-locator-form").style.display =
        "flex";
      document
        .querySelectorAll(".popup-locator-form .dealer-name")
        .forEach(($dealerName) => {
          $dealerName.innerText = document.querySelector(
            ".table-store-marker .store-name"
          ).innerText;
        });

      document.getElementById("dealeremail").value =
        document.querySelector(".marker-envelope a")?.innerText || "";
      Locator.showForm(locator_type);
      const dealerName = document.querySelector('.table-store-marker .store-name').innerText
      Locator.GAEvents(dealerName,'contact_button')
    });
    document
      .querySelectorAll(".storeify-storelocator-web")
      .forEach((link) => link.setAttribute("target", "_blank"));
      if(document.querySelector(".table-store-marker"))
    document.querySelector(".table-store-marker").appendChild(link);
    
  }
  static GAEvents(dealerName,action = "dealer_selected"){

    gtag('event', 'Dealer Map',{
      event_category:this.locationParam,
      event_action: action,
      event_label: dealerName
    })
    console.log(this.locationParam)
    console.table(`%c Event Sent: location:${this.locationParam}, action:${action}, name: ${dealerName}`,'color: white;background:rgb(133, 2, 24);padding: 5px 5px 5px 0px;');
  }
  static addDataRange (){
    let container = document.querySelector('.search-radius-box')
    let rangeComponent = container.querySelector('#radius_search');
    //range-radius
    let rangeLimits = document.createElement('div');
    rangeLimits.className = "range-limits"
    rangeLimits.innerHTML = `<span>${rangeComponent.getAttribute('min')}</span><span>${Number(rangeComponent.getAttribute('max')) / 2}</span> <span>${rangeComponent.getAttribute('max')}</span>`
   container.querySelector('.range-radius').appendChild(rangeLimits)
    console.log(`container`,container);
  }
}